import React from 'react'
import { getBrandFontOptions } from '../branding/brandConfig'
import styles from './CanvasLab.module.scss'

function inputColor(value, fallback) {
  return /^#[0-9a-f]{6}$/i.test(value || '') ? value : fallback
}

/**
 * A small Canvas view over Lugsail's shared brand-theme contract. More
 * chart-specific styling stays in the production Style workflow for now.
 */
export default function CanvasStyleControls({
  brandTheme,
  onBrandThemeChange,
  selectedChartCount = 1,
  onApplyStyleToSelection = null,
}) {
  const theme = brandTheme || {}
  const fontOptions = getBrandFontOptions()
  const update = (patch) => onBrandThemeChange({ ...theme, ...patch })

  return <section className={styles.styleControls} aria-label="Chart style controls">
    <h3>Style</h3>
    <label>
      Source note
      <input
        value={theme.subtitle || ''}
        placeholder="Source or subtitle"
        onChange={(event) => update({ subtitle: event.target.value })}
        onKeyDown={(event) => event.stopPropagation()}
      />
    </label>
    <div className={styles.colorControls}>
      <label>
        Primary
        <input
          type="color"
          value={inputColor(theme.primaryColor, '#1f77b4')}
          onChange={(event) => update({ primaryColor: event.target.value })}
        />
      </label>
      <label>
        Secondary
        <input
          type="color"
          value={inputColor(theme.secondaryColor, '#ff7f0e')}
          onChange={(event) => update({ secondaryColor: event.target.value })}
        />
      </label>
      <label>
        Background
        <input
          type="color"
          value={inputColor(theme.backgroundColor, '#ffffff')}
          onChange={(event) => update({ backgroundColor: event.target.value })}
        />
      </label>
      <label>
        Text
        <input
          type="color"
          value={inputColor(theme.textColor, '#181818')}
          onChange={(event) => update({ textColor: event.target.value, labelColor: event.target.value })}
        />
      </label>
    </div>
    <label>
      Font
      <select
        value={theme.fontFamily || fontOptions[0].value}
        onChange={(event) => update({ fontFamily: event.target.value })}
      >
        {fontOptions.map((font) => <option key={font.id} value={font.value}>{font.label}</option>)}
      </select>
    </label>
    <label>
      Label scale <span>{Math.round((Number(theme.labelFontScale) || 1) * 100)}%</span>
      <input
        type="range"
        min="0.8"
        max="1.6"
        step="0.05"
        value={Number(theme.labelFontScale) || 1}
        onChange={(event) => update({ labelFontScale: Number(event.target.value) })}
      />
    </label>
    <label>
      Mark opacity <span>{Math.round((Number(theme.markOpacity) || 1) * 100)}%</span>
      <input
        type="range"
        min="0.2"
        max="1"
        step="0.05"
        value={Number(theme.markOpacity) || 1}
        onChange={(event) => update({ markOpacity: Number(event.target.value) })}
      />
    </label>
    {selectedChartCount > 1 && onApplyStyleToSelection && <button
      type="button"
      className={styles.applyStyleButton}
      onClick={onApplyStyleToSelection}
    >
      Apply this style to {selectedChartCount - 1} selected {selectedChartCount === 2 ? 'chart' : 'charts'}
    </button>}
  </section>
}
